import React, { useState } from 'react';
import Modal from '../../../components/ui/Modal';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const TemplateSettingsModal = ({ isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState('general');
  const [settings, setSettings] = useState({
    companyName: '',
    companyLogo: '',
    defaultLanguage: 'ar',
    paperSize: 'a4',
    orientation: 'portrait',
    headerEnabled: true,
    footerEnabled: true,
    watermark: false,
    autoSave: true,
    aiAssist: true
  });

  const actions = [
    { id: 'create-template', icon: 'FilePlus', label: 'إنشاء قالب جديد', color: '#3B82F6' },
    { id: 'import-template', icon: 'Upload', label: 'استيراد قالب', color: '#10B981' },
    { id: 'export-template', icon: 'Download', label: 'تصدير القوالب', color: '#8B5CF6' },
    { id: 'duplicate', icon: 'Copy', label: 'نسخ قالب', color: '#F59E0B' },
    { id: 'customize', icon: 'Palette', label: 'تخصيص التصميم', color: '#EC4899' },
    { id: 'reset', icon: 'RotateCcw', label: 'إعادة تعيين', color: '#6B7280' }
  ];

  const handleAction = (actionId) => {
    console.log('Template settings action:', actionId);
  };

  const handleSettingChange = (field, value) => {
    setSettings(prev => ({ ...prev, [field]: value }));
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      title="إعدادات القوالب"
      footer={null}
      icon={null}
      iconColor={null}
    >
      <div className="space-y-6">
        <div className="flex gap-2 border-b border-border">
          <button
            onClick={() => setActiveTab('general')}
            className={`px-4 py-2 font-medium transition-colors ${
              activeTab === 'general' ?'text-primary border-b-2 border-primary' :'text-muted-foreground hover:text-foreground'
            }`}
          >
            عام
          </button>
          <button
            onClick={() => setActiveTab('actions')}
            className={`px-4 py-2 font-medium transition-colors ${
              activeTab === 'actions' ?'text-primary border-b-2 border-primary' :'text-muted-foreground hover:text-foreground'
            }`}
          >
            الإجراءات
          </button>
          <button
            onClick={() => setActiveTab('branding')}
            className={`px-4 py-2 font-medium transition-colors ${
              activeTab === 'branding' ?'text-primary border-b-2 border-primary' :'text-muted-foreground hover:text-foreground'
            }`}
          >
            العلامة التجارية
          </button>
        </div>

        {activeTab === 'general' && (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-foreground mb-2">اللغة الافتراضية</label>
                <select
                  value={settings?.defaultLanguage}
                  onChange={(e) => handleSettingChange('defaultLanguage', e?.target?.value)}
                  className="w-full px-3 py-2 rounded-lg border border-border bg-background text-foreground"
                >
                  <option value="ar">العربية</option>
                  <option value="en">English</option>
                  <option value="both">ثنائي اللغة</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-foreground mb-2">حجم الورق</label>
                <select
                  value={settings?.paperSize}
                  onChange={(e) => handleSettingChange('paperSize', e?.target?.value)}
                  className="w-full px-3 py-2 rounded-lg border border-border bg-background text-foreground"
                >
                  <option value="a4">A4</option>
                  <option value="letter">Letter</option>
                  <option value="legal">Legal</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-foreground mb-2">الاتجاه</label>
                <select
                  value={settings?.orientation}
                  onChange={(e) => handleSettingChange('orientation', e?.target?.value)}
                  className="w-full px-3 py-2 rounded-lg border border-border bg-background text-foreground"
                >
                  <option value="portrait">عمودي</option>
                  <option value="landscape">أفقي</option>
                </select>
              </div>
            </div>

            <div className="space-y-3">
              <h3 className="text-sm font-semibold text-foreground">خيارات المستند</h3>
              <div className="space-y-2">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={settings?.headerEnabled}
                    onChange={(e) => handleSettingChange('headerEnabled', e?.target?.checked)}
                    className="w-4 h-4 rounded border-border"
                  />
                  <span className="text-sm text-foreground">تفعيل الرأسية</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={settings?.footerEnabled}
                    onChange={(e) => handleSettingChange('footerEnabled', e?.target?.checked)}
                    className="w-4 h-4 rounded border-border"
                  />
                  <span className="text-sm text-foreground">تفعيل التذييل</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={settings?.watermark}
                    onChange={(e) => handleSettingChange('watermark', e?.target?.checked)}
                    className="w-4 h-4 rounded border-border"
                  />
                  <span className="text-sm text-foreground">علامة مائية</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={settings?.autoSave}
                    onChange={(e) => handleSettingChange('autoSave', e?.target?.checked)}
                    className="w-4 h-4 rounded border-border"
                  />
                  <span className="text-sm text-foreground">حفظ تلقائي</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={settings?.aiAssist}
                    onChange={(e) => handleSettingChange('aiAssist', e?.target?.checked)}
                    className="w-4 h-4 rounded border-border"
                  />
                  <span className="text-sm text-foreground">مساعد الذكاء الاصطناعي</span>
                </label>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'actions' && (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-3">
              {actions?.map((action) => (
                <button
                  key={action?.id}
                  onClick={() => handleAction(action?.id)}
                  className="p-4 rounded-lg border border-border hover:border-primary transition-all text-right group"
                >
                  <div className="flex items-center gap-3">
                    <div
                      className="w-10 h-10 rounded-lg flex items-center justify-center"
                      style={{ backgroundColor: `${action?.color}20` }}
                    >
                      <Icon name={action?.icon} size={20} color={action?.color} />
                    </div>
                    <span className="text-sm font-medium text-foreground group-hover:text-primary">
                      {action?.label}
                    </span>
                  </div>
                </button>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'branding' && (
          <div className="space-y-4">
            <Input
              label="اسم الشركة"
              value={settings?.companyName}
              onChange={(e) => handleSettingChange('companyName', e?.target?.value)}
              placeholder="اسم شركتك"
            />
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">شعار الشركة</label>
              <div className="border-2 border-dashed border-border rounded-lg p-6 text-center">
                <Icon name="Upload" size={32} color="var(--color-muted-foreground)" className="mx-auto mb-2" />
                <p className="text-sm text-muted-foreground">اسحب وأفلت الشعار هنا أو انقر للتحميل</p>
                <Button variant="outline" size="sm" className="mt-3">
                  اختر ملف
                </Button>
              </div>
            </div>
          </div>
        )}

        <div className="flex justify-end gap-3 pt-4 border-t border-border">
          <Button variant="outline" onClick={onClose}>
            إلغاء
          </Button>
          <Button variant="default">
            حفظ الإعدادات
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default TemplateSettingsModal;